import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import config from 'emun.on-demand/admin/_config'
import editProductPrompt from 'emun.on-demand/admin/edit-product-prompt'
import designProductPrompt from 'emun.on-demand/admin/design-product-prompt'
import downloadImagesPrompt from 'emun.on-demand/admin/download-images-prompt'
import Product from 'emun.shopping/product.model'
import ServiceBus from 'servicestack/service-bus'
import ProductQuery from 'emun.shopping/product-query.service'
import Design from 'emun.on-demand/lib/design'
import Media from 'webutils/media/media'
import modals from 'webmodals/modals'
import $session from 'servicestack/session'
import httpPoller from 'webutils/http-poller.service'

let hasValue = m => !!m;

class ProductManagerController {
    constructor($state, $stateParams) {
        basicController(this)
        const $ctrl = this;
        const $http = resolve('$http');
        let criteria = Object.assign({
            context: $stateParams.context || 'manage',
            search: $ctrl.search,
            wholesalePriceGreaterThanOrEqualTo: $ctrl.priceMin,
            wholesalePriceLessThanOrEqualTo: $ctrl.priceMax,
            active: $stateParams.context !== 'publish',
            includeInactive:true,
            onDemandProductIdGreaterThan:0,
        },
        $stateParams,{
            context: $stateParams.context || 'manage'
        });
        Object.assign($ctrl, {$state}, $stateParams);
        $ctrl.bus = new ServiceBus();
        $ctrl.navs = $state.getNav('od-products');
        let options = {
            pageSize: config.pageSize,
            orderBy: config.orderBy,
            autoLoad: true,
            append: false,
            hideLeftNav: true,
            disableQueryString: true,
            filters: config.filters,
            includeInactive:true,
            tagCriteria: $ctrl.tagCriteria,
            criteria,
            scrub(response) {
                var products = response.data.results = Product.map(response.data.results);
                products.forEach(p => {
                    //p.oversizedImages = [];
                    p.areas.forEach(a => {
                        a.design = new Design(a.design, false);
                        a.design.loadValidationResult().then(vr => {
                            p.oversizedImages = (p.oversizedImages || 0) + a.design.validationResult.oversizedImages.length;
                        });
                    });
                    console.log('p', p.img(), p);
                });
            },
            sortOptions: config.sortOptions
        }
        
        if($stateParams.context === 'publish' && $stateParams.designId > 0) {
            $ctrl.title = 'Create products for design';
            let $design = $ctrl.bus.send(`QueryMedia/${$stateParams.designId}.json`).then(
                res => {
                    console.info('design header', $ctrl.design = new Design(res.data.results[0]));
                    if($ctrl.design.label) $ctrl.title += ': ' + $ctrl.design.label;
                },
                res => console.error('no design', res)
            );
        }
        else {
            //options.url += '&IsB2B=1';
        }

        $ctrl.query = new ProductQuery(options);
    }

    editProductInfo(product) {
        const $ctrl = this;
        return editProductPrompt({
            title: `Edit Product Info`,
            subTitle: `${product.id}`,
            product
        }).then(result => {
            if(result.update) Object.assign(product, result.update);
            if(result.rename) $ctrl.renameProduct(product);
            if(result.toggleProduct) $ctrl.toggleProduct(product);
            if(result.delete) $ctrl.deleteProduct(product);
            if(result.view) $ctrl.viewProduct(product);
            if(result.design) $ctrl.openProductDesigner(product);
            if(result.downloadImages) $ctrl.downloadImages(product);
            if(result.download) $ctrl.downloadImages(product);
        });
    }

    canEditProduct(product) {
        return $session.isCorpOrAbove() || (product.tags['$RetailerId'] || []).indexOf($session.retailerId) >= 0;
    }

    openProductDesigner(product) {
        const $ctrl = this;
        return designProductPrompt({
            title: `Design Product`,
            subTitle: `${product.id}`,
            product
        }).then(
            result => {
                let $rootScope = resolve('$rootScope');
                product.imageLoaded = false;
                $rootScope.$broadcast('img-' + product.id, null, 2000);
                //Object.assign(product, result);
            }
        );
    }

    downloadImages(product) {
        const $ctrl = this;
        return downloadImagesPrompt({
            title: `Download Product Images`,
            subTitle: `${product.id}`,
            product
        });
    }

    filterStatus(active) {
        const $ctrl = this;
        $ctrl.query.criteria.active = active;
        $ctrl.query.load(true);
    }

    statusLabel(active) {
        return active === true ? 'Active' : active === false ? 'Inactive' : 'All'
    }

    toggleProduct(product, skip, activated) {
        const $ctrl = this;
        if( activated !== true && activated !== false) activated = !product.active;
        let url = `${!activated?'Dea':'A'}ctivateOnDemandProduct/${product.onDemandProductId}.json`;
        product.isB2B = product.isB2C = product.active = activated;
        $ctrl.bus.send(url);//.then(res => $ctrl.query.load(true));
    }

    toggleProducts(activated) {
        const $ctrl = this;
        $ctrl.query.results
            .filter(p =>p.selected)
            .forEach(p => $ctrl.toggleProduct(p, true, activated));
    }

    renameProduct(product) {
        const $ctrl = this;
        const oldId = product.id;
        return modals.prompt('Rename product', oldId).result.then(id => {
            return $ctrl.bus.send('RenameProduct.json', {oldId, id});//.then(res => $ctrl.query.load(true));
        });
    }

    deleteProduct(product) {
        const $ctrl = this;
        return modals.confirm('Delete product', product.shortDescription).result.then(() => {
            return $ctrl.bus.send('DeleteOnDemandProduct.json', {productId: product.id}).then(res => $ctrl.query.load(true));
        });    
    }

    editProduct(id) {
        this.$state.go('products.edit', { productId: id });
    }
    viewProduct(id) {
        this.$state.go('product.view', { productId: id });
    }

    addProduct(product) {
        const $ctrl = this;
        let $cart = resolve('$cart');
        !product.active && $ctrl.toggleProduct(product, true, true);
        $cart.addProduct(product);
    }

    addProducts() {
        const $ctrl = this;
        $ctrl.query.results
            .filter(p =>p.selected)
            .forEach(p => $ctrl.addProduct(p));
    }
    selectAllProducts(select) {
        const $ctrl = this;
        $ctrl.query.results
            .forEach(p => p.selected = (select === true || select === false) ? select : true);
    }
    downloadProductData() {
        const $ctrl = this;
        var request = {
            productIds: []
        };

        $ctrl.query.results
            .filter(p =>p.selected)
            .forEach(p => request.productIds.push(p.id));
        return location.href = $ctrl.$appConfig.serviceUrl + "SubmitProductsToExcel.csv?ProductIds=" + request.productIds.join(',');
    }
    addTags() {
        return modals.alert('This feature has not been implemented as of yet.', 'Under Construction');
    }

    $onDestroy() {
        this.query.dispose();
    }
}

export default ProductManagerController;